import React, { memo } from 'react';
import Dialog from '@mui/material/Dialog';
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';
import Typography from '@mui/material/Typography';

import DialogTitleWithCloseIcon from '../DialogTitleWithCloseIcon/DialogTitleWithCloseIcon';

const DeleteAlertDialog = ({ title, subtitle, description, open, handleClose, children }) => (
  <Dialog maxWidth="md" style={{ textAlign: 'center' }} open={open} onClose={handleClose}>
    <DialogTitleWithCloseIcon onClose={handleClose}>{title}</DialogTitleWithCloseIcon>
    <DialogContent>
      <Typography variant="subheading">
        <strong>{subtitle}</strong>
      </Typography>
      <br />
      <Typography variant="body2" gutterBottom>
        {description}
      </Typography>
    </DialogContent>
    <DialogActions style={{ justifyContent: 'center' }}>{children}</DialogActions>
  </Dialog>
);

export default memo(DeleteAlertDialog);
